import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { IBaseModel } from '../models/base.model';
import { Servico } from '../models/catalogo-es.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CatalogoEsService extends BaseService {
    controllerRoute = 'CatalogoEs';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public async getServicosOrganizacao(id: string): Promise<IBaseModel<Servico[]>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<Servico[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/ServicosOrganizacao/${id}`));
    }
}
